var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('aron-table',{key:_vm.route,attrs:{"endPoint":_vm.route,"filterEndpoint":_vm.filterEndpoint,"formType":_vm.formType,"viewOnly":_vm.viewOnly,"showAddBtn":_vm.showAddBtn,"showActionButton":_vm.showActionButton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }